import {
    HttpEvent,
    HttpHandler,
    HttpInterceptor,
    HttpRequest,
  } from '@angular/common/http';
  import { Injectable } from '@angular/core';
  import { Observable } from 'rxjs';
  
  @Injectable()
  export class LanguageInterceptorService implements HttpInterceptor {
    intercept(
      request: HttpRequest<any>,
      next: HttpHandler
    ): Observable<HttpEvent<any>> {
      if (request.url.includes('/es-DO')) {
        const modifiedRequest = request.clone({
          url: request.url.replace('/es-DO', ''),
        });
        return next.handle(modifiedRequest);
      }
      if ( request.url.includes('/en-US')) {
        const modifiedRequest = request.clone({
          url: request.url.replace('/en-US', ''),
        });
        return next.handle(modifiedRequest);
      }

      return next.handle(request);
    }
  }
  